import { ActionMenu, ActionMenuItem } from './ActionMenu';

export interface TurnIntoItem {
  id: string;
  label: string;
  icon: React.ReactNode;
  /** Set on every item when the list marks the current type; left out when it does not. */
  current?: boolean;
}

interface TurnIntoMenuProps {
  items: TurnIntoItem[];
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onTurnInto: (id: string) => void;
  label: string;
  trigger: React.ReactElement;
  side: 'top' | 'bottom';
  portalContainer?: HTMLElement | null;
}

/** "Turn into" list shared by the multi-block selection bar and the text selection bar. */
export function TurnIntoMenu({
  items,
  open,
  onOpenChange,
  onTurnInto,
  label,
  trigger,
  side,
  portalContainer,
}: TurnIntoMenuProps): React.ReactElement {
  return (
    <ActionMenu
      open={open}
      onOpenChange={onOpenChange}
      label={label}
      className="menu--turn"
      side={side}
      align="start"
      portalContainer={portalContainer}
      trigger={trigger}
    >
      {items.map((item) => (
        <ActionMenuItem
          key={item.id}
          className={item.current ? 'menu__item nb is-on' : 'menu__item nb'}
          onSelect={() => onTurnInto(item.id)}
        >
          {item.current === undefined ? null : (
            <span className="selbar__tick" aria-hidden="true">
              {item.current ? '✓' : ''}
            </span>
          )}
          {item.icon}
          <span className="blk-menu__name">{item.label}</span>
        </ActionMenuItem>
      ))}
    </ActionMenu>
  );
}
